import React from 'react';
import {
  OnClick,
  OnPaymentAuthorized,
  OnPaymentAuthorizedInit,
  OnShippingContactSelected,
} from '../../types/ExternalContract';
import { Layout } from '../../types/Styles';
import { useSelector } from '../../store';
import { selectAvailableMethods } from '../../selectors/payment';
import { ExpandableList } from './components/ExpandableList';
import { Fieldset } from './components/Fieldset';

interface Props {
  isCollapsed?: boolean;
  layout: Layout;
  onClick: OnClick; // TODO not used
  onShippingContactSelected: OnShippingContactSelected;
  onPaymentAuthorizedInit: OnPaymentAuthorizedInit;
  onPaymentAuthorized: OnPaymentAuthorized;
  onExpand(): void;
}

export const PaymentMethodsListView: React.FC<Props> = (props) => {
  const { layout, isCollapsed, onExpand } = props;
  const availableMethods = useSelector(selectAvailableMethods);

  if (availableMethods.length === 0) {
    return null;
  }

  if (layout === 'horizontal') {
    return <Fieldset />;
  }

  if (layout === 'vertical') {
    return <ExpandableList isCollapsed={isCollapsed} onExpand={onExpand} />;
  }

  return null;
};
